import React, { HTMLAttributes } from "react";
import { Container, TextArea as StyledTextArea, Label } from "./styles";

type Props = {
  placeholder?: string;
  onChange: Function;
  value: string;
  label?: string;
  labelWeight?: "normal" | "bold";
  rows?: number;
  resize?: "none" | "vertical" | "horizontal";
} & HTMLAttributes<HTMLTextAreaElement>;

const TextArea = ({
  value,
  placeholder = "",
  onChange,
  label = "",
  labelWeight = "normal",
  rows = 4,
  resize = "vertical",
  ...restProps
}: Props) => (
  <Container>
    {label && <Label weight={labelWeight}>{label}</Label>}
    <StyledTextArea
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      rows={rows}
      resize={resize}
      {...restProps}
    />
  </Container>
);

export default TextArea;
